import FileUpload from 'MediaManager/components/FileUpload'
import { staticAuthConfig, uploadFileToGCP, uploadFileToS3 } from 'MediaManager/helpers/s3'
import React, { useEffect, useState } from 'react'
import Button from 'shared/components/Button'
import DragFileUpload from 'shared/components/DragFileUpload'
import Loader from 'shared/components/Loader'
import { generatePresignedUrl } from 'shared/helpers/s3'

function ModelUpload({ onChange, preview }) {
  const [url, setUrl] = useState()
  const [previewUrl, setPreviewUrl] = useState()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (preview) {
      ;(async () => {
        const key = preview.indexOf('.glb') > -1 ? preview : `${preview}.glb`
        const signedUrl = await generatePresignedUrl(key, staticAuthConfig)
        setPreviewUrl(signedUrl)
      })()
    }
  }, [preview])

  async function preparePreview(file) {
    if (!file) {
      setPreviewUrl(null)
      setUrl(null)
      onChange(null)
      return
    }
    setLoading(true)
    const url = await uploadFileToS3(file, `temp-preview/${file.name}-${Date.now()}`, 'sparx-secured-cdn')
    const signedUrl = await generatePresignedUrl(url, staticAuthConfig)
    setUrl(signedUrl)
    setLoading(false)
    onChange(file)
  }

  return (
    <div>
      {!url && !loading && !preview && (
        <div className={`${loading ? 'opacity-50 pointer-events-none' : ''}`}>
          <DragFileUpload hintText="Drag 3D model" type="glb" onPicked={(files) => preparePreview(files[0])} />
        </div>
      )}
      {(url || preview) && (
        <div>
          <Button rounded onClick={() => preparePreview(null)}>
            Remove model
          </Button>
        </div>
      )}
      {loading && <Loader />}
      {(url || previewUrl) && (
        <div className="mt-[32px]">
          <iframe
            src={`https://3d-viewer-dev.sparx.ai?url=${btoa(previewUrl || url)}`}
            className="h-[850px] w-full"
            title="3d-viewer"
          />
        </div>
      )}
    </div>
  )
}

export default ModelUpload
